// extracted by mini-css-extract-plugin
export default {"wrapper":"Form_wrapper__dGstu","root":"Form_root__hQqAv","item":"Form_item__bJ48U","erklearvideoButton":"Form_erklearvideoButton__wq1B+"};